<template>
  <div class="spinner-overlay">
    <div class="spinner-overlay__wrapper">
      <SpinnerLoading size="l" />
    </div>
  </div>
</template>

<script>
/**
 * Компонент для отображения процесса загрузки в виде модального окна.
 */
export default {};
</script>

<style lang="scss">
@use "./style.scss";
</style>
